module.exports = __webpack_public_path__ + "static/media/battery.f2864866.svg";